import React from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';

const Layout = ({ children }) => {
  return (
    <div className="app-shell">
      <SiteHeader />
      <main className="page-content">{children}</main>
      <SiteFooter />
    </div>
  );
};

export default Layout;
